'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { Heading, Button, Picture } from '../../index.js';
export const PromoBanner = (_a) => {
    var { className, children, href, cta, onClick, imgAlt, imgSrc, imageItems, inverted, title, size, target, linkLabel, headingTagName = 'h2', buttonVariant = 'primary', centerText = false } = _a, other = __rest(_a, ["className", "children", "href", "cta", "onClick", "imgAlt", "imgSrc", "imageItems", "inverted", "title", "size", "target", "linkLabel", "headingTagName", "buttonVariant", "centerText"]);
    const handleClick = (e) => {
        if (href) {
            if (onClick) {
                onClick(e);
            }
        }
    };
    const isCenterAllowed = !size || size === 'sm' ? !cta : true;
    const hasLink = Boolean(href);
    const componentClassName = classnames('sparky-c-promo-banner', className, {
        'sparky-c-promo-banner--sm': size === 'sm',
        'sparky-c-promo-banner--md': size === 'md',
        'sparky-c-promo-banner--md-alt': size === 'md-alt',
        'sparky-c-promo-banner--lg': size === 'lg',
        'sparky-c-promo-banner--xlg': size === 'xlg',
        'sparky-c-promo-banner--inverted': inverted,
        'sparky-c-promo-banner--clickable': hasLink,
        'sparky-c-promo-banner--center': isCenterAllowed && centerText,
    });
    const TagName = hasLink ? 'a' : 'div';
    const getHeadingSize = () => {
        switch (size) {
            case 'sm':
                return 'body-lg-bold';
            case 'md':
                return 'headline';
            case 'md-alt':
                return 'title-lg';
            case 'lg':
                return 'title';
            case 'xlg':
                return 'title-xl';
            default:
                return 'headline';
        }
    };
    return (_jsx(TagName, Object.assign({ href: hasLink ? href : undefined, target: hasLink ? target : undefined, onClick: handleClick, className: componentClassName, tabIndex: hasLink ? 0 : undefined }, other, { children: _jsxs("div", Object.assign({ className: "sparky-c-promo-banner__band" }, { children: [_jsx(Picture, { className: "sparky-c-promo-banner__picture", imgAlt: imgAlt, imgSrc: imgSrc, items: imageItems }), _jsxs("div", Object.assign({ className: "sparky-c-promo-banner__body" }, { children: [_jsxs("div", Object.assign({ className: "sparky-c-promo-banner__content" }, { children: [_jsx(Heading, Object.assign({ tagName: headingTagName, size: getHeadingSize(), className: "sparky-c-promo-banner__title" }, { children: title })), children && (_jsx("div", Object.assign({ className: "sparky-c-promo-banner__description" }, { children: children })))] })), cta && (_jsx(Button, { size: size === 'sm' ? 'sm' : undefined, text: linkLabel, variant: buttonVariant, className: "sparky-c-promo-banner__button" }))] }))] })) })));
};
//# sourceMappingURL=PromoBanner.js.map